export default __webpack_public_path__ + "static/O0114-02854045f6c6ed52ff1c23cdfe9c7324.png";